import RoomType from '../roomType';
export default class Bathroom extends RoomType {
  constructor() {
    super();
    this.id = 'Bathroom';
    this.name = "Bad";
    this.icon = "mdi-shower";
    this.stateQuestions = {
      'questions': [
        {
          'id': 'doors',
          'title': 'Dører',
          'active': true,
          'value': -1
        },
        {
          'id': 'floor',
          'title': 'Gulv',
          'active': true,
          'value': -1
        },
        {
          'id': 'taps',
          'title': 'Servant og kran',
          'active': true,
          'value': -1
        },
        {
          'id': 'closet',
          'title': 'Skap',
          'active': true,
          'value': -1
        },
        {
          'id': 'shower',
          'title': 'Dusjkabinett/dusjdører og dusjhjørne',
          'active': true,
          'value': -1
        },
        {
          'id': 'toilet',
          'title': 'Toalett',
          'active': true,
          'value': -1
        },
        {
          'id': 'walls',
          'title': 'Vegger',
          'active': true,
          'value': -1
        },
        {
          'id': 'heating',
          'title': 'Varme',
          'active': true,
          'value': -1
        },
        {
          'id': 'outlets',
          'title': 'Stikkontakter og lysbrytere',
          'active': true,
          'value': -1
        },
        {
          'id': 'ventilation',
          'title': 'Ventilasjon',
          'active': true,
          'value': -1
        },
        {
          'id': 'drain',
          'title': 'Sluk',
          'active': true,
          'value': -1
        },
        {
          'id': 'washing_machine',
          'title': 'Vaskemaskin',
          'active': true,
          'value': -1
        },
        {
          'id': 'dryer',
          'title': 'Tørketrommel',
          'active': true,
          'value': -1
        }
      ]
    };

    this.contentTypes.options.unshift(
      {
        'id': 'shower',
        'title': 'Dusj',
        'active': true,
        'value': -1
      },
      {
        'id': 'shower_cabinet',
        'title': 'Dusjkabinett',
        'active': false,
        'value': -1
      },
      {
        'id': 'toilet',
        'title': 'Toalett',
        'active': true,
        'value': -1
      },
      {
        'id': 'wall_toilet',
        'title': 'Vegghengt toalett',
        'active': false,
        'value': -1
      },
      {
        'id': 'bath',
        'title': 'Badekar',
        'active': false,
        'value': -1
      },
      {
        'id': 'sink',
        'title': 'Servant med underskap',
        'active': true,
        'value': -1
      },
      {
        'id': 'cabinets',
        'title': 'Overskap',
        'active': true,
        'value': -1
      },
      {
        'id': 'washing_machine',
        'title': 'Opplegg til vaskemaskin',
        'active': true,
        'value': -1
      },
      {
        'id': 'dryer',
        'title': 'Plass til tørketrommel',
        'active': false,
        'value': -1
      },
      {
        'id': 'exhaust',
        'title': 'Avtrekksvifte',
        'active': true,
        'value': -1
      },
    );
  }
}